import { history } from "@/utils/history";
import {cookieService} from '@/services/cookie';

// const setAuthToken = token => {
// 	return {
// 		type: "SET_AUTH_TOKEN",
// 		token,
// 	};
// };
const signIn = ({token}) => {
	sessionStorage.setItem('csrf', token);
	sessionStorage.setItem('firstLoginDefaultDepartment', true);
	sessionStorage.setItem('firstLoginDefaultVersion', true);
	cookieService.setToken(token);

	return {
		type: "SET_AUTH_ISLOGGEDIN",
		token,
	};
};
const signOut = (redirect = true) => {
	sessionStorage.setItem('csrf', '');
	cookieService.removeToken();
	if (redirect) { history.push('/'); }
	return {
		type: "SET_AUTH_SIGNOUT",
	};
};
const setLoginReturnUrl = payload => {
	return {
		type: "SET_LOGIN_RETURNURL",
		payload,
	};
};

const setUser = value => {
	return {
		type: "SET_USER",
		value,
	};
};

export const authActions = {
	signIn,
	signOut,
	setLoginReturnUrl,
	setUser,
};
